import { StringKey } from '../../../lang/index';
import { SafeSortBy } from '../../../types/safes.types';
import { InvestmentType } from '../hooks/index';

export enum Column {
  AMOUNT_DUE = 'amount-due',
  CAP_TYPE = 'cap-type',
  CAP_VALUE = 'cap-value',
  DISCOUNT = 'discount',
  EMPTY = 'empty',
  FLOOR = 'floor',
  INVESTMENT = 'investment',
  ISSUE_DATE = 'issue-date',
  MATURITY_DATE = 'maturity-date',
}

export const investmentTypeTranslationKey: Record<InvestmentType, StringKey> = {
  [InvestmentType.FUNDRAISING_ROUND]: 'INVESTMENT',
  [InvestmentType.SAFE]: 'SAFE',
};

export const columnTranslationKey: Record<Column, StringKey> = {
  [Column.INVESTMENT]: 'INVESTMENT',
  [Column.AMOUNT_DUE]: 'AMOUNT_DUE',
  [Column.ISSUE_DATE]: 'ISSUE_DATE',
  [Column.CAP_VALUE]: 'CAP_VALUE',
  [Column.CAP_TYPE]: 'CAP_TYPE',
  [Column.DISCOUNT]: 'DISCOUNT',
  [Column.FLOOR]: 'FLOOR',
  [Column.MATURITY_DATE]: 'MATURITY_DATE',
  [Column.EMPTY]: 'EMPTY',
};

export const sortColumn: PartialRecord<Column, SafeSortBy> = {
  [Column.ISSUE_DATE]: SafeSortBy.ISSUE_DATE,
  [Column.CAP_VALUE]: SafeSortBy.CAP_VALUE,
  [Column.CAP_TYPE]: SafeSortBy.CAP_TYPE,
  [Column.DISCOUNT]: SafeSortBy.DISCOUNT,
  [Column.FLOOR]: SafeSortBy.FLOOR,
  [Column.MATURITY_DATE]: SafeSortBy.MATURITY_DATE,
};

export const columnOrderMap = Object.keys(columnTranslationKey);
